import "./ProgressBar.css";

// `value` out of `max` (a percentage by default), clamped to the bar.
const ProgressBar = ({ value = 0, max = 100, className = "", label, valueText }) => {
  const ratio = (Number(value) / (Number(max) || 100)) * 100;
  const percent = Number.isFinite(ratio) ? Math.min(100, Math.max(0, ratio)) : 0;

  return (
    <div
      className={`ui-progress-wrap ${className}`}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(percent)}
      aria-label={label}
      aria-valuetext={valueText}
    >
      <div className="ui-progress-fill" style={{ width: `${percent}%` }} />
    </div>
  );
};

export default ProgressBar;